<template>
	<transition name='fade'>
		<canvas class='path' ref='canvas' :width='width' :height='height'></canvas>
	</transition>
</template>

<script>
	import _ from "lodash";
	import * as d3 from "d3";
	import BezierEasing from "bezier-easing";

	const duration = 1500;
	const steps = 100;

	export default {
		name: "CanvasTracePath",

		props: {
			mapping: {},
			trace: {},
			width: 0,
			height: 0
		},

		data () {
			return {
				path: null,
				interval: null,
				step: 0,
				start: null
			};
		},

		mounted () {
			this.canvas = this.$refs.canvas;
			this.context = this.canvas.getContext('2d');
			this.start = window.performance.now();
			window.requestAnimationFrame(this.draw);
		},

		computed: {
			points: function () {
				let first = _.first(this.trace.nodes);
				let last = _.last(this.trace.nodes);
				let midpoint = {
					x: (first.x + last.x) / 2,
					y: (first.y + last.y) / 2,
				};
				let dx = Math.abs(first.x - last.x);
				let dy = Math.abs(first.y - last.y);
				return [
					[first.x, first.y],
					[midpoint.x + (dy * 0.1), midpoint.y - (dx * 0.2)],
					[last.x, last.y],
				];
			},

			d: function () {
				return d3.line().curve(d3.curveBasis)(this.points);
			},

			len: function () {
				let path = document.createElementNS("http://www.w3.org/2000/svg", "path");
				path.setAttribute("d", this.d);
				return path.getTotalLength();
			}
		},
		methods: {
			draw(timestamp) {
				if (!this.context) {
					return;
				}

				// if (!this.start) this.start = window.performance.now();
				// if (!this.start) this.start = timestamp;
				const dt = timestamp - this.start;
				let current = dt / duration;

				if (current > 1) current = 1;

				let context = this.context;

				let first = _.first(this.trace.nodes);
				let last = _.last(this.trace.nodes);

				let midpoint = {
					x: (first.x + last.x) / 2,
					y: (first.y + last.y) / 2,
				};

				this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);

				context.beginPath();

				let lingrad = context.createLinearGradient(
					first.x, first.y, last.x, last.y
				);
				lingrad.addColorStop(0, "rgba(255, 0, 0, 100)");
				lingrad.addColorStop(1, "rgba(242, 103, 33, 255)");

				let path = new Path2D(this.d);
				path.moveTo(first.x, first.y);

				context.setLineDash([this.len, this.len]);
				context.lineDashOffset = this.len * (1 - current);

				context.strokeStyle = lingrad;
				context.strokeWidth = "20px";
				context.stroke(path);

				context.closePath();

				if (current < 1)
					window.requestAnimationFrame(this.draw);
			}
		}
	}
</script>

<style scoped>
	.fade-leave-active {
		transition: opacity 0.3s;
	}

	.fade-leave-to {
		opacity: 0;
	}
</style>

